module.exports = __webpack_public_path__ + "static/media/logo-colcx-white-2.0ae1f95e.svg";